/**
 * Construye URL de WhatsApp (wa.me) a partir de un teléfono guardado en perfil.
 * Normaliza a dígitos; si no parece incluir código de país AR, antepone 54.
 */
export function buildWhatsAppUrl(phone, message) {
  let d = String(phone || '').replace(/\D/g, '');
  if (!d) return '';
  if (d.startsWith('0')) d = d.replace(/^0+/, '');
  if (!d.startsWith('54') && d.length >= 8 && d.length <= 10) {
    d = `54${d}`;
  }
  const q = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${d}${q}`;
}
